// @ts-nocheck
import { injectCss } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CardStylesProvider } from "@store/Library/Widgets/Card/useCardStyles";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import React, { CSSProperties } from "react";
import styled, { css, useTheme } from "styled-components";

export type CardStyles = InjectableCss;

const Card = styled.div<InjectableCss>`
    ${injectCss}
`;

const LinkCard = styled.a<InjectableCss>`
    ${injectCss}
`;
const defaultCardStyles: CardStyles = {
    css: css`
        display: flex;
        position: relative;
        min-width: 0;
        overflow-wrap: break-word;
    `,
};
export interface CardProps {
    className?: string;
    direction?: CSSProperties["flexDirection"];
    align?: CSSProperties["alignContent"];
    justify?: CSSProperties["justifyContent"];
    variant?: keyof Toolkit.Theme.Card["variants"];
    size?: keyof Toolkit.Theme.Card["sizes"];
    extendedStyles?: CardStyles;
    overrideStyles?: CardStyles;
    href?: string;
}
const CardComponent: React.FC<CardProps> = ({
    variant,
    size,
    extendedStyles,
    overrideStyles,
    direction = "column",
    align = "normal",
    children,
    justify = "normal",
    href,
    className,
}) => {
    const theme = useTheme();
    const sizeStyles = theme?.card?.sizes[size ?? "medium"];
    const variantStyles = theme?.card?.variants[variant ?? "elevated"].wrapper;
    const cardStyles: InjectableCss = {
        css: css`
            ${defaultCardStyles.css}
            ${sizeStyles?.css}
            ${variantStyles?.css}
            flex-direction: ${direction};
            align-items: ${align};
            justify-content: ${justify};
        `,
    };
    const styles = useExpandProps(cardStyles, extendedStyles, overrideStyles);

    return (
        <CardStylesProvider variant={variant} size={size}>
            {href ? (
                <LinkCard {...styles} className={className} href={href}>
                    {children}
                </LinkCard>
            ) : (
                <Card {...styles} className={className}>
                    {children}
                </Card>
            )}
        </CardStylesProvider>
    );
};

export default CardComponent;
